import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { TelegramLogo, CheckCircle, SpinnerGap } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export default function TelegramLinkCard() {
  const [status, setStatus] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const pollRef = useRef(null);

  const fetchStatus = async () => {
    try {
      const r = await axios.get(`${API}/api/telegram/status`, { headers: authHeaders() });
      setStatus(r.data);
      return r.data;
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    fetchStatus();
    return () => clearInterval(pollRef.current);
  }, []);

  const connect = async () => {
    try {
      const r = await axios.post(`${API}/api/telegram/link-code`, null, { headers: authHeaders() });
      window.open(r.data.url, '_blank', 'noopener');
      setWaiting(true);
      let tries = 0;
      clearInterval(pollRef.current);
      pollRef.current = setInterval(async () => {
        tries += 1;
        const s = await fetchStatus();
        if (s?.linked || tries > 40) {
          clearInterval(pollRef.current);
          setWaiting(false);
        }
      }, 3000);
    } catch (e) { /* ignore */ }
  };

  const unlink = async () => {
    try {
      await axios.post(`${API}/api/telegram/unlink`, null, { headers: authHeaders() });
      fetchStatus();
    } catch (e) { /* ignore */ }
  };

  return (
    <div className="bg-white dark:bg-neutral-800 rounded-xl shadow-md p-6" data-testid="telegram-link-card">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2 mb-1">
        <TelegramLogo size={20} weight="fill" className="text-[#1C93E3]" /> Telegram Alerts
      </h3>
      {status?.linked ? (
        <div>
          <p className="text-sm text-emerald-700 dark:text-emerald-400 font-semibold flex items-center gap-1.5 mt-2" data-testid="telegram-linked-status">
            <CheckCircle size={16} weight="fill" />
            Connected{status.telegram_username ? ` as @${status.telegram_username}` : status.telegram_first_name ? ` (${status.telegram_first_name})` : ''}
          </p>
          <p className="text-xs text-gray-500 mt-1">Job alerts, offers and messages are delivered to your Telegram chats.</p>
          <button onClick={unlink} className="mt-3 text-xs font-bold text-red-500 underline" data-testid="telegram-unlink-btn">
            Disconnect Telegram
          </button>
        </div>
      ) : (
        <div>
          <p className="text-sm text-gray-500 dark:text-neutral-400">
            Get every job alert, offer and message instantly in your Telegram chats — with one-tap buttons to respond.
          </p>
          {waiting ? (
            <p className="mt-3 text-sm font-semibold text-[#1C93E3] flex items-center gap-1.5" data-testid="telegram-waiting-status">
              <SpinnerGap size={16} className="animate-spin" /> Waiting — tap <strong>Start</strong> in the Telegram chat we just opened...
            </p>
          ) : (
            <button
              onClick={connect}
              className="mt-3 inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-[#1C93E3] text-white rounded-lg hover:opacity-90"
              data-testid="telegram-connect-btn"
            >
              <TelegramLogo size={16} weight="fill" /> Connect Telegram
            </button>
          )}
        </div>
      )}
    </div>
  );
}
